//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "Pagination",

  data: function () {
    return {
      pagination: [],
    }
  },

  props: ["page", "perPage", "pageCount", "totalCount", "loading", "linkPagination", "linkPaginationFirst"],
  computed: {
    shows: function () {
      const shows = this.page * this.perPage - (this.perPage - 1);

      if (this.totalCount < shows) {
        return this.totalCount;
      }

      return this.page * this.perPage - (this.perPage - 1);
    },
    total: function () {
      return this.totalCount;
    },


    infoMessage: function () {
      return `${this.$t('pagination.showing')} ${this.shows} - ${(this.page * this.perPage > this.totalCount) ? this.totalCount : this.page * this.perPage} ${this.$t('pagination.of')} ${this.total}`
    }
  },

  watch: {
    page: function () {
      this.initPagination();
    },
    pageCount: function () {
      this.initPagination();
    },
    totalCount: function () {
      this.initPagination();
    },
  },

  created: function () {
    this.initPagination();
  },

  mounted: function () {
    this.initPagination();
  },

  methods: {
    initPagination: function () {
      var page = this.page;
      var siblingCount = 1;
      var boundaryCount = 1;
      var count = this.pageCount;
      var range = function range(start, end) {
        var length = end - start + 1;
        return Array.from(
          {
            length: length,
          },
          function (_, i) {
            return start + i;
          }
        );
      };

      var startPages = range(1, Math.min(boundaryCount, count));
      var endPages = range(
        Math.max(count - boundaryCount + 1, boundaryCount + 1),
        count
      );
      var siblingsStart = Math.max(
        Math.min(
          page - siblingCount,
          count - boundaryCount - siblingCount * 2 - 1
        ),
        boundaryCount + 2
      );
      var siblingsEnd = Math.min(
        Math.max(page + siblingCount, boundaryCount + siblingCount * 2 + 2),
        endPages[0] - 2
      );

      let items = [].concat(
        startPages,
        siblingsStart > boundaryCount + 2
          ? ["start-ellipsis"]
          : boundaryCount + 1 < count - boundaryCount
            ? [boundaryCount + 1]
            : [],
        range(siblingsStart, siblingsEnd),
        siblingsEnd < count - boundaryCount - 1
          ? ["end-ellipsis"]
          : count - boundaryCount > boundaryCount
            ? [count - boundaryCount]
            : [],
        endPages
      );

      this.pagination = items.map((item) => {
        if (typeof item === "number") {
          return {title: item, page: item};
        }

        return {title: "...", disabled: true};
      });
    },

    onLoadMore: function () {
      this.$emit("onLoadMore");
    },
    onChangePage: function (item) {
      if (item.disabled) {
        return
      }

      document.getElementById('scroll-container').scrollTo({ top: 0, left: 0 });
      this.$emit("onChangePage", item.page);
    },

    _getLinkPaginationButton: function (item) {
      if (item.disabled) {
        return ""
      }
      if (!this.linkPagination) {
        return ""
      }

      if (item.page === 1) {
        return this.linkPaginationFirst
      }
      return (this.linkPagination || "").replace("$page", item.page);
    }
  },
};
